<template>
  <div class="login">
    <input type='text' class='phone' placeholder='请输入店铺名称' v-model='name'>
    <p class="tips" >您尚未提交您的店铺名称</p>
    <button @click='submit()' class="login-btn">确认</button>
  </div>
</template>
<style scoped lang="scss">
    @import "../utils.scss";

    .login {
      height: 100%;
      height: 100vh;
      width: 100%;
      box-sizing: border-box;
      background: url("../assets/pic.jpg") no-repeat;
      padding: px2rem(125px) px2rem(60px) px2rem(60px) px2rem(60px);
      background-size: cover;
    }


    .tips {
        @include font-dpr(12px);
        color: #F52013;
        line-height: 12px;
        margin: px2rem(10px) 0;
    }

    .clear-phone {
      display: inline-block;
      height: px2rem(18px);
      width: px2rem(18px);
      transform: translateY(-140%);
      margin-bottom: 8px;
      background: url("../assets/clear.png");
      background-size: contain;
      vertical-align: middle;
      float: right;
    }

    .get-code {
      background: rgba(255,255,255,.14);
      padding: 0 px2rem(10px);
      height: px2rem(26px);
      line-height: px2rem(26px);
      border-radius: px2rem(62px);
      color: rgba(255,255,255, .6);
      @include font-dpr(13px);
      transform: translateY(-130%);
      margin-bottom: 8px;
      border: 0;
      float: right;
    }
    .phone, .code {
      width: px2rem(255px);
      height: px2rem(36px);
      line-height: px2rem(36px);
      @include font-dpr(16px);
      background: transparent;
      color: white;
      opacity: .6;
      border: 0;
      border-bottom: 1px solid white;
    }




    .login-btn {
        width: px2rem(255px);
        height: px2rem(48px);
        background: #79BD50;
        box-shadow: 0 px2rem(-2px) px2rem(4px) 0 rgba(0,0,0,0.10);
        border-radius: px2rem(4px);
        @include font-dpr(18px);
        color: #FFFFFF;
        line-height: px2rem(48px);
        margin-top: px2rem(87px);
        border: 0px;
    }
</style>
<script>
import {checkMobile} from '../utils.js'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'hello',
  data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      phone:'',
      code:'',
      buttonText: '获取验证码',
      phoneValidate: true,
      codeValidate: true,
    };
  },
  computed: {
    showTip() {
      return !checkMobile(this.phone);
    },
    ...mapGetters({
       config: 'config',
    }),
  },
 
  methods: {
    submit() {
      this.$http.put(this.config.host + '/api/customer/name-register', {
           phone: this.$route.query.phone, name: this.name
          }).then(res=>{
            if(res.data.data.success){
              this.$router.replace('/');
          }
          console.log(data)
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->




// WEBPACK FOOTER //
// NameRegister.vue?5ab6c202